import { BoxProps } from "@mui/material";
import "azure-maps-control/dist/atlas.min.css";
import { useMemo } from "react";

import { GeoHelper } from "@/common/helpers/geo";
import { GeoMarkerOptions } from "@/common/ts/geo";
import { GeoJsonPointDto } from "@/core/api/generated/v1";

import GeolocationMap from "./GeolocationMap";

interface Props {
  value: Nil<GeoJsonPointDto>;
  markerOptions?: Partial<GeoMarkerOptions>;
  sx?: BoxProps["sx"];
}

export default function GeolocationPointDisplay({ value, markerOptions, sx }: Props) {
  const stateResetKey = useMemo(
    () => (value ? GeoHelper.getCoordinatesAsString(value) : undefined),
    [value],
  );

  const marker = useMemo(
    () => (value ? GeoHelper.createMarkerFromGeoPoint({ point: value, markerOptions }) : undefined),
    [value],
  );

  return (
    <GeolocationMap
      key={stateResetKey}
      sx={sx}
      markers={{
        markers: marker ? [marker] : [],
        isZoomAtFirst: true,
        isCenterAtFirst: true,
        canAdd: false,
        canRemove: false,
        canDrag: false,
      }}
    />
  );
}
